export const http = {
  timeout: 1200000,
  shortTimeout: 3000,
}
